/**
 * Device Fingerprinting Utility
 * Creates a unique identifier for the current browser/device
 * Used to bind payment sessions to specific devices
 */

export const generateDeviceFingerprint = async () => {
  const components = [];
  
  // Screen info
  components.push(window.screen.width);
  components.push(window.screen.height);
  components.push(window.screen.colorDepth);
  components.push(window.devicePixelRatio || 1);
  
  // Timezone
  components.push(Intl.DateTimeFormat().resolvedOptions().timeZone);
  
  // Language
  components.push(navigator.language);
  
  // Platform
  components.push(navigator.platform);
  
  // User agent (partial)
  components.push(navigator.userAgent.slice(0, 50));
  
  // Canvas fingerprint
  try {
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    ctx.textBaseline = 'top';
    ctx.font = '14px Arial';
    ctx.fillText('Skybot', 2, 2);
    components.push(canvas.toDataURL().slice(-50));
  } catch (e) {
    components.push('no-canvas');
  }
  
  // WebGL info
  try {
    const canvas = document.createElement('canvas');
    const gl = canvas.getContext('webgl') || canvas.getContext('experimental-webgl');
    if (gl) {
      const debugInfo = gl.getExtension('WEBGL_debug_renderer_info');
      if (debugInfo) {
        components.push(gl.getParameter(debugInfo.UNMASKED_RENDERER_WEBGL));
      }
    }
  } catch (e) {
    components.push('no-webgl');
  }
  
  // Create hash from components
  const str = components.join('|||');
  
  // Simple hash function
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    const char = str.charCodeAt(i);
    hash = ((hash << 5) - hash) + char;
    hash = hash & hash;
  }
  
  // Convert to hex string
  const fingerprint = Math.abs(hash).toString(16).padStart(8, '0') + 
                     Date.now().toString(16).slice(-8);
  
  return fingerprint;
};

// Get or create persistent fingerprint
export const getDeviceFingerprint = async () => {
  let fp = localStorage.getItem('skybot_device_fp');
  if (!fp) {
    fp = await generateDeviceFingerprint();
    localStorage.setItem('skybot_device_fp', fp);
  }
  return fp;
};
